import AppContext from "PFApp/app_context";
import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { FeatureFlag } from "PFTypes";
import { useContext, useEffect } from "react";

export const useChameleonProfilePayload = () => {
  const {
    store: { currentAccount }
  } = useContext(AppContext);

  const { data: currentProfile } = useCurrentProfile();

  const isEnabled = useIsFeatureEnabled();

  useEffect(() => {
    if (isEnabled(FeatureFlag.Chameleon) && window.chmln && currentProfile?.logged_in) {
      window.chmln.identify(currentProfile.id, {
        role: currentProfile.roles[0],
        permission_group: currentProfile.permissions_group.name,
        company_name: currentAccount.full_domain,
        grade: currentProfile.grade?.[0]?.["value"],
        location: currentProfile.location?.[0]?.["value"],
        service_line: currentProfile.service_line?.[0]?.["value"]
      });
    }
  }, [!!window.chmln, currentProfile?.logged_in]);
};
